import {
  ARTICLES,
  getArticleTitlePlain,
} from "@/pages/common/Home/Dissection/Articles";
import {IntroArticle} from "@/pages/common/Home/Dissection/IntroArticle";

import {useEffect} from "react";

import {Helmet} from "react-helmet";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useParams} from "react-router-dom";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {opacity: 0},
  visible: {
    opacity: 1,
    transition: {
      delay: 0.3,
    },
  },
};

export const Paragraph = ({children}) => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      viewport={{amount: 0, once: true}}
      variants={itemAnimation}
      className={styles.article_paragraph}
    >
      {children}
    </motion.div>
  );
};

export const Article = () => {
  const {t} = useTranslation();
  const {id} = useParams();
  const location = useLocation();
  const article = id != null && ARTICLES?.[id];
  const articleTitle = article ? getArticleTitlePlain(article) : "";

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location]);

  return (
    <>
      {articleTitle && (
        <Helmet
          title={t("head_title.article", {title: articleTitle})}
        />
      )}

      <div className={"container-big"}>
      <div className={styles.article}>
        <IntroArticle />

        <div className={styles.article_wrapper}>
          <BorderArticle>
            <div className={styles.article_wrap}>
              <div className={styles.article_breadcrumbs}>
                <RootDesc>
                  <Link to={"/resources"}>{t("header.nav.analytics")}</Link>
                  <span> / </span>
                  <b>
                    {id &&
                      ARTICLES &&
                      ARTICLES.length > 0 &&
                      ARTICLES[id]?.title}
                  </b>
                </RootDesc>
              </div>

              {id && ARTICLES && ARTICLES.length > 0 && ARTICLES[id]?.body}
            </div>
          </BorderArticle>
        </div>
      </div>
    </div>
    </>
  );
};
